// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DataStreamListItem
 */
export interface DataStreamListItem {
    /**
     * 
     * @type {Date}
     * @memberof DataStreamListItem
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof DataStreamListItem
     */
    dataStreamId: string;
    /**
     * 
     * @type {Date}
     * @memberof DataStreamListItem
     */
    lastModifiedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof DataStreamListItem
     */
    specId: string;
    /**
     * 
     * @type {string}
     * @memberof DataStreamListItem
     */
    studyId: string;
}

/**
 * Check if a given object implements the DataStreamListItem interface.
 */
export function instanceOfDataStreamListItem(value: object): value is DataStreamListItem {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('dataStreamId' in value) || value['dataStreamId'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('specId' in value) || value['specId'] === undefined) return false;
    if (!('studyId' in value) || value['studyId'] === undefined) return false;
    return true;
}

export function DataStreamListItemFromJSON(json: any): DataStreamListItem {
    return DataStreamListItemFromJSONTyped(json, false);
}

export function DataStreamListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataStreamListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'dataStreamId': json['dataStreamId'],
        'lastModifiedAt': (new Date(json['lastModifiedAt'])),
        'specId': json['specId'],
        'studyId': json['studyId'],
    };
}

export function DataStreamListItemToJSON(json: any): DataStreamListItem {
    return DataStreamListItemToJSONTyped(json, false);
}

export function DataStreamListItemToJSONTyped(value?: DataStreamListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'dataStreamId': value['dataStreamId'],
        'lastModifiedAt': ((value['lastModifiedAt']).toISOString()),
        'specId': value['specId'],
        'studyId': value['studyId'],
    };
}
